import React from "react";
import DocumentationListPresenter from "./DocumentationList.presenter";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { MapStateToProps, MapDispatchToProps, C_Props, MergedProps, C_States } from "./DocumentationList.type";
import {
  AppNotifications,
  DocumentFlag,
  DocumentOutputModel,
  DocumentStatus,
  RootState,
  TCb,
} from "../../../../models";
import { NotificationActions } from "../../../../store/actions";
import _ from "lodash";

import { INITIAL_FETCHING_PAGINATION_DATA } from "../../../../constants";

import { DocumentService } from "../../../../services";
import { loadCallback } from "../../../../utils";
import { withRouter } from "react-router-dom";

class DocumentationListContainer extends React.Component<MergedProps, C_States> {
  constructor(props) {
    super(props);

    this.state = {
      fetchedDocument: INITIAL_FETCHING_PAGINATION_DATA,
      allDocuments: [],
      categoryFlag: DocumentFlag.ABOUTUS,
      filter: {
        categoryId: "",
        searchValue: "",
        cateFlag: DocumentFlag.ABOUTUS
      },
    };
  }

  handleChangeStatus = (document: DocumentOutputModel, newStatus: string) => {
    const updateStatus = newStatus === DocumentStatus.PUBLISH ? DocumentStatus.UNPUBLISH : DocumentStatus.PUBLISH

    DocumentService.updateStatus(document.id, {status: updateStatus})
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.onApplyFilter(false);
          this.props.actions.enqueueSnackbar({ type: AppNotifications.SUCCESS, message: "Update status success" });
        }
        else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Update status failed" });
        }
      })
      .catch((err) => {
        console.log(err)
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Update status failed" });
      });
  }

  onSearch = _.debounce((searchValue: string) => {
    this.setState(
      (prevState) => {
        return {
          filter: {
            ...prevState.filter,
            searchValue,
          },
        };
      },
      () => {
        this.onApplyFilter(false);
      }
    );
  }, 300);

  onChangeCategory = (categoryId: string, cateFlag: DocumentFlag) => {
    this.setState(
      {
        categoryFlag: cateFlag,
        filter: {
          ...this.state.filter,
          categoryId,
          cateFlag
        },
      },
      () => {
        this.onApplyFilter(false);
      }
    );
  };

  onDeleteDocument = (documentId: string) => {
    DocumentService.deleteFile(documentId)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Delete file success",
          });
          loadCallback(this.reloadListingPage);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Delete file failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Delete file failed" });
      });
  };

  onApplyFilter = (loadMore: boolean, cb?: TCb) => {
    if (this.state.fetchedDocument.loading && loadMore) return;

    this.setState(
      (prevState) => {
        return {
          fetchedDocument: {
            ...prevState.fetchedDocument,
            data: loadMore ? prevState.fetchedDocument.data : [],
            loading: true,
          },
        };
      },
      () => {
        const query: Parameters<typeof DocumentService.getFileByCategory>[0] = {
          page: loadMore ? this.state.fetchedDocument.page + 1 : 1,
          limit: this.state.fetchedDocument.limit,
          flag: this.state.categoryFlag || DocumentFlag.ABOUTUS
        };

        DocumentService.getFileByCategory(query)
          .then((res) => {
            if (res && res.data?.data) {
              this.setState(
                (prevState) => {
                  let document: DocumentOutputModel[] = [...res.data.data];

                  if (loadMore) {
                    document.unshift(...prevState.fetchedDocument.data);
                  }

                  return {
                    fetchedDocument: {
                      ...res.data,
                      data: document,
                      loading: false,
                    },
                    allDocuments: document
                  };
                },
                () => {
                  if (res.data.page < res.data.totalPages) {
                    this.onApplyFilter(true)
                  }
                  loadCallback(cb?.success);
                }
              );
            } else {
              this.props.actions.enqueueSnackbar({
                type: AppNotifications.ERROR,
                message: "Load file data failed",
              });
              this.setState({
                fetchedDocument: INITIAL_FETCHING_PAGINATION_DATA,
              });
            }
          })
          .catch((err) => {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Load file data failed",
            });
            this.setState({
              fetchedDocument: INITIAL_FETCHING_PAGINATION_DATA,
            });
          });
      }
    );
  };

  onLoadMore = () => {
    this.onApplyFilter(true);
  };

  reloadListingPage = () => {
    this.onApplyFilter(false);
  }

  componentDidMount() {
    this.onApplyFilter(false);
  }

  render() {
    return (
      <DocumentationListPresenter
        {...this.props}
        {...this.state}
        onChangeCategory={this.onChangeCategory}
        onLoadMore={this.onLoadMore}
        onSearch={this.onSearch}
        reloadListingPage={this.reloadListingPage}
        onDeleteDocument={this.onDeleteDocument}
        handleChangeStatus={this.handleChangeStatus}
      />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({}),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions), dispatch),
    })
  )(DocumentationListContainer)
);
